import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetChangelogQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetChangelogQuery = { __typename?: 'query_root', changelog: Array<{ __typename?: 'changelog', id: any, description: string, release_date: any }> };


export const GetChangelogDocument = gql`
    query getChangelog {
  changelog {
    id
    description
    release_date
  }
}
    `;

/**
 * __useGetChangelogQuery__
 *
 * To run a query within a React component, call `useGetChangelogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChangelogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChangelogQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetChangelogQuery(baseOptions?: Apollo.QueryHookOptions<GetChangelogQuery, GetChangelogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChangelogQuery, GetChangelogQueryVariables>(GetChangelogDocument, options);
      }
export function useGetChangelogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChangelogQuery, GetChangelogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChangelogQuery, GetChangelogQueryVariables>(GetChangelogDocument, options);
        }
export function useGetChangelogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChangelogQuery, GetChangelogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChangelogQuery, GetChangelogQueryVariables>(GetChangelogDocument, options);
        }
export type GetChangelogQueryHookResult = ReturnType<typeof useGetChangelogQuery>;
export type GetChangelogLazyQueryHookResult = ReturnType<typeof useGetChangelogLazyQuery>;
export type GetChangelogSuspenseQueryHookResult = ReturnType<typeof useGetChangelogSuspenseQuery>;
export type GetChangelogQueryResult = Apollo.QueryResult<GetChangelogQuery, GetChangelogQueryVariables>;